import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.set.js";
import "core-js/modules/web.dom-collections.iterator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//

// 接口api
import { getDepartmentList } from 'api/common';
import Vue from 'vue';
var placeholder = Vue.prototype.$t('221');
export default {
  name: 'department',
  props: {
    placeholder: {
      type: String,
      default: placeholder
    },
    mprop: {
      type: Object,
      default: function _default() {}
    },
    change: {
      type: Function,
      default: function _default() {
        return function () {};
      }
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var self = this;
    return {
      department_id: 1,
      currentSel: '',
      props: {
        lazy: true,
        leaf: 'is_sub_department',
        value: 'department_id',
        label: 'department_name',
        multiple: this.multiple,
        lazyLoad: function lazyLoad(node, resolve) {
          getDepartmentList({
            department_id: node && node.data && node.data.department_id ? node.data.department_id : self.department_id
          }).then(function (res) {
            var data = res.data;
            var arr = data.map(function (item) {
              item.is_sub_department = !item.is_sub_department;
              return item;
            });
            resolve(arr);
          });
        }
      }
    };
  },
  created: function created() {
    this.props = _objectSpread(_objectSpread({}, this.props), this.mprop);
  },
  methods: {
    // 注册事件返回
    changeDepartMethod: function changeDepartMethod(val) {
      var selectArr = [];
      var obj = this.$refs.cascader.getCheckedNodes(true)[0];
      var deep = function deep() {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var arr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        data.data && arr.unshift(data.data);
        if (data.parent) deep(data.parent, arr);
        return arr;
      };
      if (this.multiple) {
        var arr = JSON.parse(JSON.stringify(val));
        arr = arr.toString().split(',');
        selectArr = Array.from(new Set(arr));
      }
      // selectArr在多选数组时可用
      this.change(deep(obj), val, selectArr);
    }
  }
};